<template>
    <div class="publish_div">
        <h4>编写行动笔记</h4>
        <div class="editor_component" style="width: 50%">
            <CKEditor @text="get_content"></CKEditor>
        </div>
        <div class="publish_tools">
            <div class="publish_tags">
                <span class="publish_tag">
                    保存至:
                </span>
                <span class="publish_tag publish_tag_active">
                </span>
            </div>
            <div class="publish_operation_tools">
                <button class="publish_button" @click="save()">保存</button>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import CKEditor from '@/components/common_components/ckeditor/ckeditor.vue'
    import planApi from '@/api/plan/plan_api.js'
    import {mapState, mapActions, mapGetters} from 'vuex'


    export default {
        components: {
            CKEditor,
        },
        data: function () {
            return {
                preview: true,
                content: '',
            }
        },
        computed: {
            ...mapState({

            }),
            ...mapGetters({

            })
        },
        methods: {
            ...mapActions({

            }),
            get_content: function (content) {
                this.content = content
            },
            save: async function () {

            },
        },
        mounted() {

        }
    }

</script>
<style type="text/css" scoped>

    .publish_div {
        /*width: 660px;*/
        height: calc(100vh - 120px);
        /*margin: auto;*/
        border: white 1px solid;

        padding: 18px 30px;
        display: flex;
        flex-direction: column;
    }


    .editor_component {
        /*border: none !important;*/
        /*flex-grow: 1;*/
        margin-bottom: 120px;
    }

    .publish_tools {
        position: fixed;
        width: 50%;
        bottom: 0;
        left: 25%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        margin-top: 10px;
        background: #f9f9f9;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
    }

    .publish_tags {
        color: #333;
        font-size: 14px;
        font-weight: 700;
        display: flex;
    }

    .publish_tag {
        /*font-weight: 500;*/
        padding: 2px 10px;
        margin-right: 10px;
        border-radius: 20px;
        cursor: pointer;
    }

    .publish_tag_active {
        color: #fff;
        background: #4e5d63;
    }

    .publish_operation_tools {
        display: flex;

    }

    .publish_button {
        padding: 6px 20px;
        background: rgb(8, 191, 145);
        border: 1px solid transparent;
        border-radius: 4px;
        font-size: 16px;
        text-align: center;
        color: #fff;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        margin-right: 5px;
    }

    .publish_button:hover {
        color: #fff;
        background: #069a75;
    }


</style>
